import * as React from "react";
export const renderPlaceholderBtn = (componentPrefix) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons` },
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-text` }),
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-odd` })),
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons` },
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-text` }),
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-odd` })),
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons` },
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-text` }),
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__buttons-odd` })),
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__empty-element` })));
};
//# sourceMappingURL=renderPlaceholderBtn.js.map